import { render, staticRenderFns } from "./CollarLeashPersonalize.vue?vue&type=template&id=0f52fcc4&scoped=true&"
import script from "./CollarLeashPersonalize.vue?vue&type=script&lang=js&"
export * from "./CollarLeashPersonalize.vue?vue&type=script&lang=js&"
import style0 from "./CollarLeashPersonalize.vue?vue&type=style&index=0&id=0f52fcc4&prod&lang=scss&scoped=true&"
import style1 from "./CollarLeashPersonalize.vue?vue&type=style&index=1&id=0f52fcc4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f52fcc4",
  null
  
)

export default component.exports